import { ChipMetadata, RadioButton } from '@pmi/dsm-react';
import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import { AgreementApiModel } from '../../models/DealModel';
import { ProductApiModel } from '../../models/ProductModel';
import styles from './addUser.module.scss';
import wizardStyles from './wizard.module.scss';
import AgreementSelectedProducts from './AgreementSelectedProducts';
import DomainForm from './DomainForm';
import EmailForm from './EmailForm';

interface AddUsersProps {
  products: ProductApiModel[];
  deal: AgreementApiModel;
  emailTags: string[];
  setEmailTags: Dispatch<SetStateAction<string[]>>;
  onSuccess: () => void;
  mode: 'org' | 'email' | undefined;
  setMode: (v: 'org' | 'email' | undefined) => void;
}

export default function AddUsers(props: AddUsersProps) {
  const { products, deal, emailTags, setEmailTags, onSuccess, mode, setMode } =
    props;
  const [radioMode, setRadioMode] = useState<'org' | 'email' | undefined>(mode);
  const onModeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRadioMode(event.target.value as 'org' | 'email');
  };
  const onModeSubmit = () => {
    setMode(radioMode);
    setRadioMode(undefined);
  };
  if (mode === 'email' || !deal.isPayByUser) {
    return (
      <EmailForm
        products={products}
        deal={deal}
        emailTags={emailTags}
        setEmailTags={setEmailTags}
        onSuccess={onSuccess}
      />
    );
  }
  if (mode === 'org') {
    return <DomainForm products={products} deal={deal} onSuccess={onSuccess} />;
  }

  return (
    <div className="d-block">
      <h3>How would you like to invite people?</h3>
      <hr className="mt-3 mb-4" />
      <div className={`${wizardStyles.inviteFormContainer} gap-5`}>
        <div className="d-block flex-grow-1">
          <div>
            <div className={`${styles.modeSelect} d-flex mb-3 rounded-1`}>
              <div className={styles.radioWrapper}>
                <RadioButton
                  onChange={onModeChange}
                  value="email"
                  id="email-radio"
                  name="radio-buttons-users-add-type"
                  checked={radioMode === 'email'}
                />
              </div>
              <div className="ms-2">
                <div className={`${styles.headerBlock} gap-2 mb-1`}>
                  <div className="d-block">
                    <ChipMetadata text="Most Common" variant="green" />
                  </div>
                  <div className="d-block">
                    <h3>Invite by Email</h3>
                  </div>
                </div>
                <p>
                  Invite one or many users directly by entering their email
                  address (or uploading a .csv).
                </p>
              </div>
            </div>
            <div className={`${styles.modeSelect} d-flex mb-3 rounded-1`}>
              <div className={styles.radioWrapper}>
                <RadioButton
                  onChange={onModeChange}
                  value="org"
                  id="org-radio"
                  name="radio-buttons-users-add-type"
                  checked={radioMode === 'org'}
                />
              </div>
              <div className="ms-2">
                <div className={`${styles.headerBlock} gap-2 mb-1`}>
                  <div className="d-block">
                    <ChipMetadata
                      text="Great for Sharing Company-Wide"
                      variant="aqua"
                    />
                  </div>
                  <div className="d-block">
                    <h3>Invite by Domain-based Access</h3>
                  </div>
                </div>
                <p>
                  Specify a domain like mycompany.com and anyone who’s email
                  address ends with @mycompany.com can access.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-none d-md-block d-sm-block"
          style={{ paddingBottom: '300px' }}
        />
        <div className="d-block d-sm-none" style={{ paddingBottom: '210px' }} />
        <div className="d-block">
          {products && products.length > 0 && (
            <AgreementSelectedProducts
              products={products}
              deal={deal}
              onClick={onModeSubmit}
              disabled={!radioMode}
              buttonText="Continue"
              isInviteStep
            />
          )}
        </div>
      </div>
    </div>
  );
}
